import PagingTableFooter from '../table/PagingTableFooter';
import React, { Component } from 'react';

export class Pager extends Component {
    emitPaginationChanged = updatedPagination => {
        this.props.onPaginationChanged &&
            this.props.onPaginationChanged(updatedPagination);
    };

    updatePageSize = pageSize => {
        if (pageSize) {
            const paginationArgs = {
                ...this.props.pagination,
                pageSize
            };

            this.emitPaginationChanged(paginationArgs);
        }
    };
    updatePageNumber = page => {
        const paginationArgs = {
            ...this.props.pagination,
            page
        };

        this.emitPaginationChanged(paginationArgs);
    };

    render() {
        const { page, hasNextPage, pageSize } = this.props.pagination;

        return (
            <PagingTableFooter
                colspan={this.props.colspan}
                page={page}
                hasNextPage={hasNextPage}
                noOfItems={pageSize}
                updateNoOfItems={pageSize => this.updatePageSize(pageSize)}
                gotToFirstPage={() => this.updatePageNumber(1)}
                goToPrevPage={() => this.updatePageNumber(page - 1)}
                goToNextPage={() => this.updatePageNumber(page + 1)}
                goToLastPage={() => this.updatePageNumber()}
            />
        );
    }
}
